import { MANUAL } from 'modules/addon/duck/model';
import { Selector } from 'model/State';
import { isAcademicSwitchOn } from 'modules/settings/academic';

export const selectIsAcademicAvailable: Selector<boolean> = (state) =>
  !!state.addon && state.addon.mode === MANUAL;

export const selectIsAcademicOn: Selector<boolean> = (state) =>
  selectIsAcademicAvailable(state) && isAcademicSwitchOn(state);
